import React from 'react';
import { graphql } from 'gatsby';
import GraphQLErrorList from '../components/graphqlerrorlist';
import SEO from '../components/seo';
import LayoutContainer from '../containers/layout';
import TextComponent from '../components/TextComponent/textComponent';
import BilateralBlock from '../components/Bilateral/BilateralBlock/bilateralBlock';
import BilateralImage from '../components/Bilateral/BilateralImage/bilateralImage';
import BilateralContainerLayout from '../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import FeaturedContainer from '../components/Featured/featured';
import homepage_data from '../normalization/homePage';
import HeroInro from '../components/HeroInto/heroInto';
import HeroSection from '../components/HeroSection/heroSection';
import Button from '../components/Button/button';

export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;

const IndexPage = (props) => {
  const HomePageData = homepage_data();
  const { data, errors } = props;
  if (errors) {
    return (
      <LayoutContainer>
        <div className="home">
          <GraphQLErrorList errors={errors} />
        </div>
      </LayoutContainer>
    );
  }

  const { site } = data || {};
  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }
  const {
    home: { hero, featuredContainer, bilateralContainer, heroIntro },
  } = HomePageData;
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Home`} description={site.description} keywords={site.keywords} />
      {hero && <HeroSection heroBannerImage={hero.hero_image.webUrl} headlineText={heroIntro.headlineText} layoutStyle={hero.className} />}
      {heroIntro && (
        <HeroInro
          description={heroIntro.description}
          showIcon={heroIntro.showIcon && true}
          linksBtn={heroIntro.links.data}
          layoutStyle={heroIntro.className}
        />
      )}
      {bilateralContainer && (
        <BilateralContainerLayout layoutStyle={bilateralContainer.layoutStyle}>
          {bilateralContainer.bilateralList.map((block) => (
            <BilateralBlock key={Math.random().toString(36).substring(7)} layoutStyle={block.className}>
              <TextComponent
                heading={block.textComponent.headline}
                description={block.textComponent.description}
                linksBtn={block.textComponent.links.data}
                layoutStyle={block.textComponent.className}
              />
              {block.bilateralImage && <BilateralImage src={block.bilateralImage.webUrl} alt={block.bilateralImage.alt} />}
            </BilateralBlock>
          ))}
        </BilateralContainerLayout>
      )}
      {featuredContainer && (
        <>
          {featuredContainer.data.map((featured) => {
            return (
              <FeaturedContainer
                key={Math.random().toString(36).substring(7)}
                featuredTextCompList={featured.featuredTextCompList}
                featuredThumbnailList={featured.featuredThumbnailList}
                partnerLogoGrid={featured.partnerLogoGrid}
                description={featured.description}
                featureHeading={featured.featureHeading}
                buttonText={featured.buttonText}
                buttonLinkTo={featured.linkTo}
                props={props}
              />
            );
          })}
        </>
      )}
      <div style={{textAlign:"center",marginBottom:"40px"}}>
       <Button title="Learn More" linkTo="/our-pawtners" buttonStyle="primary-outline-style"  />
       </div>
    </LayoutContainer>
  );
};

export default IndexPage;
